
import { HttpClient, HttpParams } from '@angular/common/http';
import { LazyLoadEvent, TreeNode } from 'primeng/primeng'; 
import { Observable } from 'rxjs';

import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { UbigeoType } from '../../shared/_utils/services/ubigeoType.enum';
import { Register } from '../entities/register';
import { IncomeRule } from '../entities/incomeRule';
import { IncomeUse } from '../entities/incomeUse'; 
import { Tupa } from '../entities/tupa';
import { IncomeOwnerService } from './income-owner.service';
import { IncomeRuleService } from './income-rule.service';
import { IncomeUseService } from './income-use.service';
//import { ProvinceService } from './province.service';
import { SpinnerService } from './spinner.service';
import { Injectable, Injector } from '@angular/core';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service'; 
import {  tap} from 'rxjs/operators';


@Injectable()
export class RegisterService  extends BaseCrudService<Register>
  {

   // protected rutaServidor = localStorage.getItem('rutaServidor');
   // protected httpParams = new HttpParams();
    public uri = '/api/register/';

    constructor(injector: Injector) {
        super(injector); 
       //console.log('Instance RegisterService');
    }
 
 
    buildSentence(entity?: Register, event?: LazyLoadEvent): HttpParams {
        if (entity) {
            let query = entity.code ? 'code' + QueryOperator.Contain + entity.code + QueryOperator.Split : QueryOperator.Empty;
            query = query.concat(entity.name ? 'name' + QueryOperator.Contain + entity.name + QueryOperator.Split : QueryOperator.Empty);
            this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
        }

        if (event) {
            const page = ((event.first + event.rows) / event.rows - 1 ).toString();
            const size = event.rows.toString();
            this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
            this.httpParams =  this.httpParams.set(QueryOperator.SizeParam, size);
        }
        return this.httpParams;
    }
  
    getRegister(eu_id: number):Observable<any>{   
        const rutaServidor = localStorage.getItem('rutaServidor');
       //console.log("rutaServidor :" + rutaServidor);
        const url =  rutaServidor + '/api/register/treeNode'
       //console.log("url :" + url);
        this.spinnerService.showAll();
      return this.httpClient.get(url+"?eu_id="+eu_id);
    }
 
 
}



// WEBPACK FOOTER //
// ./src/app/core/services/register.service.ts